import { render } from "./SideNavigation.vue?vue&type=template&id=64810331"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__